import React, { Component } from 'react';
import './styles.css';
import { connect } from 'react-redux';
import spanish from '../../../common/language/spanis';
import english from '../../../common/language/english';
import layout from '../../../common/layout';
import { ResortsActions } from '../../../redux/resorts';
import Grid from '@material-ui/core/Grid';
import { Link } from "react-router-dom";


let lang = spanish;

class Resorts extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    componentDidMount() {
        const { fetchResorts } = this.props;
        fetchResorts();
    }

    componentWillReceiveProps(next) {
        if (next.language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }

    resortsList = (resorts) => {
        const { setCurrentResort } = this.props;
        return resorts.map((item, key) => {
            return (
                <Grid item lg={6} xs={12} key={key} style={{ marginTop: -22 }}>
                    <Link to="/resortInfo" onClick={() => setCurrentResort(item)}>
                        <div className="itemImg" style={{ backgroundImage: `url(${item.img})` }}>
                            <div className="overlay">
                                <h3 className="name">{item.name}</h3>
                            </div>
                        </div>
                    </Link>
                </Grid>
            )
        });
    }

    render() {
        const { resorts } = this.props;
        return (
            <div id="resorts">
                <p className="mainTitle">{lang.rooms.title}</p>
                <Grid
                    container
                    direction="row"
                    className="rowContainer"
                >
                    {resorts && this.resortsList(resorts)}
                </Grid>
            </div>

        );
    }
}

const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
    resorts: state.ResortsReducer.resorts,
});

const mapDispatchToProps = dispatch => ({
    fetchResorts: () => {
        dispatch(ResortsActions.fetchResorts());
    },
    setCurrentResort: (currentResort) => {
        dispatch(ResortsActions.setCurrentResort(currentResort));
    },
});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Resorts);

